import React from "react";
import TabCard from "./TabCard";
import SearchForm from "./SearchForm";
import WaitTimeWidget from "./WaitTimeWidget";
import SearchBlock from "./SearchBlock";
import { ImageProvider } from "../../../utils/image-provider";

const TabSection = ({
  data,
  arrival_flight_icon,
  departure_icon,
  selectedTab,
  setSelectedTab,
}) => {
  const {
    bg_color,
    tabs_section,
    title,
    title_color,
    watermark_1,
    watermark_2,
  } = data || {};

  const gradientColorList = [
    "#f84f31",
    "#ff9155",
    "#f84f31",
    "#b52d34",
    "#3a6896",
    "#f99d1c",
  ];

  return (
    <div
      className="lg:mt-[-1vw] mt-[-2vw] relative flex flex-col gap-[6vw] xl:gap-[3vh] px-[5%] xl:px-[7%] py-[2vh] xl:py-[4vh]"
      style={{ backgroundColor: bg_color }}
    >
      {/* Watermarks */}
      {watermark_1?.url && (
        <ImageProvider
          Image={watermark_1}
          alt={watermark_1.alternativeTextt || "Image"}
          fetchPriority="high"
          loading="eager"
          tailwindStyle={`hidden xl:block pointer-events-none absolute left-[-4vw] top-[-2.5vw] w-[25vw]  h-auto opacity-80 z-0`}
        />
      )}
      {watermark_2?.url && (
        <ImageProvider
          Image={watermark_2}
          alt={watermark_2?.alternativeText || "Image"}
          fetchPriority="high"
          loading="eager"
          tailwindStyle={`hidden xl:block pointer-events-none absolute right-[-12vw] top-[18vw] w-[35vw] h-auto opacity-80 z-0`}
        />
      )}

      {/* Title & Tab Selector */}
      <div className="flex flex-row justify-between md:gap-[1vw] gap-[3vw] py-[2vh] xl:py-[3vh] mx-auto items-center z-10 relative">
        <p
          className="text-[5vw] xl:text-[3vh] font-redhatMedium"
          style={{ color: title_color }}
        >
          {title?.toUpperCase()}
        </p>

        <label htmlFor="flightTabSelect" className="sr-only">
          Flight Filter
        </label>
        <select
          id="flightTabSelect"
          aria-label="Flight Filter"
          className="text-[4.5vw] xl:text-[3.2vh] font-redhatMedium px-[2vw] xl:px-[2.5vh] py-[3vw] xl:py-[1.4vh] rounded-[1vh] bg-white text-black shadow focus:outline focus:outline-2 focus:outline-white focus:outline-offset-2"
          onChange={(e) => setSelectedTab(parseInt(e.target.value))}
          value={selectedTab}
        >
          {tabs_section?.map((item, index) => (
            <option
              key={index}
              value={index}
              className="font-redhatRegular text-[3vw] xl:text-[3vh]"
            >
              {item?.tab_name?.toUpperCase()}
            </option>
          ))}
        </select>
      </div>

      <div className="relative w-full z-[20] bg-white rounded-[1.5vw]">
        <SearchBlock
          tab_name={tabs_section[selectedTab]?.tab_name}
          arrival_flight_icon={arrival_flight_icon}
          departure_icon={departure_icon}
        />
      </div>
      <div>
        <WaitTimeWidget />
      </div>
      {/* Cards Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[5vw] xl:gap-[1.5vw] z-10 relative tab-card-grid">
        {tabs_section[selectedTab]?.cards_section?.map((card, idx) => (
          <TabCard key={idx} data={card} gr_color={gradientColorList[idx]} />
        ))}
      </div>
    </div>
  );
};

export default TabSection;
